/**
 * Shared imperative helpers for links.
 */

/**
 * Closes the mobile navigation drawer after a link click.
 * Centralised so components do not each reach for `document.body`.
 */
export const unlockBodyScroll = () => {
  if (typeof document !== 'undefined') {
    document.body.classList.remove('is-nav-open');
  }
};

/**
 * True when a link target points at the same URL we are already on, so the
 * header can mark it as the current page (and `aria-current`).
 */
export const isSamePath = (pathname, to) => {
  if (!to) return false;
  const target = to.split('#')[0];
  if (target === '/') return pathname === '/';
  return pathname === target || pathname.startsWith(`${target}/`);
};

/**
 * Extracts the `#section` portion of a link target, or an empty string.
 */
export const getHash = (to) => {
  const index = String(to).indexOf('#');
  return index === -1 ? '' : String(to).slice(index + 1);
};
